import { render, staticRenderFns } from "./JdsEcho.vue?vue&type=template&id=f5624f6e&scoped=true&"
import script from "./JdsEcho.vue?vue&type=script&lang=ts&"
export * from "./JdsEcho.vue?vue&type=script&lang=ts&"
import style0 from "./JdsEcho.vue?vue&type=style&index=0&id=f5624f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5624f6e",
  null
  
)

export default component.exports